
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/[service]/preco/[serviceSlug]",
      function () {
        return require("private-next-pages/[category]/[service]/preco/[serviceSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/[service]/preco/[serviceSlug]"])
      });
    }
  